// plugins/v-calendar.client.ts
import DesignSystem from "@wewiink/design-system";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(DesignSystem);
});